import { useTranslations } from '@ms/yammer-i18n-react';
import PanesStrings from '@ms/yammer-strings/dist/Panes';
import useOpenCloseState from '@ms/yammer-web-core-ui/dist/util/useOpenCloseState';
import { PageContextValue } from 'components/PageContext';
import { Dispatch, SetStateAction, useMemo, useState } from 'react';

interface PageStateDispatchers {
  readonly setShouldDisplayContentPanelButton: Dispatch<SetStateAction<boolean>>;
}

type UsePageState = () => [PageContextValue, PageStateDispatchers];
export const usePageState: UsePageState = () => {
  const t = useTranslations(PanesStrings);
  const openCloseState = useOpenCloseState();
  const [shouldDisplayContentPanelButton, setShouldDisplayContentPanelButton] = useState(false);

  const pageState = useMemo(
    () => ({
      isContentPanelOpen: openCloseState.isOpen,
      shouldDisplayContentPanelButton,
      showContentSidebarAriaLabel: t.showAdditionalInformationPane(),
      closeContentPanel: openCloseState.close,
      openContentPanel: openCloseState.open,
    }),
    [openCloseState, shouldDisplayContentPanelButton, t]
  );

  const dispatchers = useMemo(() => ({ setShouldDisplayContentPanelButton }), []);

  return [pageState, dispatchers];
};
